import type { IconProps } from '../../types/icon-props';

export const WentWrong = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg width="121" height="120" viewBox="0 0 121 120" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Frame">
        <g id="Group">
          <g id="Clip path group">
            <mask
              id="mask0_2982_24024"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="121"
              height="120"
            >
              <g id="a">
                <path id="Vector" d="M0.5 0.000358582H120.5V120H0.5V0.000358582Z" fill="white" />
              </g>
            </mask>
            <g mask="url(#mask0_2982_24024)">
              <g id="Group_2">
                <path
                  id="Vector_2"
                  d="M99.0546 72.5303L37.1685 100.456C33.629 102.053 29.4648 100.479 27.8676 96.939L21.3935 82.592C19.7964 79.0523 21.371 74.8881 24.9105 73.2909L86.7965 45.3652C90.3361 43.7679 94.5002 45.3427 96.0975 48.8822L102.572 63.2292C104.169 66.7689 102.594 70.9333 99.0546 72.5303Z"
                  fill="white"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_3"
                  d="M55.0261 108.746L54.9708 108.771C51.2354 110.456 46.8408 108.795 45.1552 105.059L42.0781 98.2402L55.6608 92.1113L58.7377 98.9302C60.4233 102.666 58.7616 107.06 55.0261 108.746Z"
                  fill="white"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_4"
                  d="M93.5066 91.3806L93.4513 91.4054C89.7158 93.091 85.3213 91.4293 83.6357 87.6938L80.5586 80.875L94.1413 74.7461L97.2182 81.565C98.9038 85.3004 97.2421 89.6949 93.5066 91.3806Z"
                  fill="white"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_5"
                  d="M51.793 77.5074L72.1667 68.3139"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_6"
                  d="M84.1483 46.559L69.185 31.5135L56.8904 37.0614L53.8203 38.4468"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_7"
                  d="M39.4557 44.9299L37.5652 45.783L26.1758 50.9221L27.5567 72.0969"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_8"
                  d="M2.84375 109.399H118.156"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_9"
                  d="M41.3708 82.2102L41.3708 82.2102C42.1583 83.9554 41.3819 86.0089 39.6365 86.7964L39.6364 86.7965C37.8911 87.5842 35.8378 86.8077 35.0503 85.0624L41.3708 82.2102ZM41.3708 82.2102C40.5833 80.4648 38.5298 79.6883 36.7843 80.4759L41.3708 82.2102ZM36.7843 80.4759C35.0392 81.2634 34.2627 83.3169 35.0502 85.0624L36.7843 80.4759Z"
                  fill="#CCE7FE"
                  stroke="#686869"
                  strokeWidth="3"
                />
                <path
                  id="Vector_10"
                  d="M84.3233 59.0246L84.3235 59.0246C86.0688 58.2369 88.1223 59.0134 88.9098 60.7586L84.3233 59.0246ZM84.3233 59.0246C82.5783 59.8119 81.8017 61.8653 82.5893 63.6109C83.3768 65.3562 85.43 66.1327 87.1755 65.3452L84.3233 59.0246ZM87.1756 65.3451C88.921 64.5573 89.6974 62.5041 88.9099 60.7587L87.1756 65.3451Z"
                  fill="#CCE7FE"
                  stroke="#686869"
                  strokeWidth="3"
                />
                <path
                  id="Vector_11"
                  d="M46.3154 28.5076L44.8472 16.1787L41.3908 29.12L40.9928 30.6099L39.5146 30.1709L32.1391 27.9807L36.5787 34.2662L37.7246 35.8886L35.8505 36.5468L24.6139 40.4933L37.5785 41.2105L39.1195 41.2957L38.9904 42.8337L38.4068 49.7864L43.7144 44.6768L44.6899 43.7376L45.7236 44.6124L51.0411 49.112L50.1762 42.1685L50.0049 40.7929L51.3627 40.5138L58.2859 39.0906L52.2575 35.5178L51.0824 34.8214L51.6661 33.5864L54.898 26.748L48.4266 29.6954L46.5581 30.5463L46.3154 28.5076Z"
                  fill="#CCE7FE"
                  stroke="#686869"
                  strokeWidth="3"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

WentWrong.displayName = 'WentWrong';
